<div *ngIf="snackbarService.isVisible$ | async as isVisible">
  <ng-container *ngIf="snackbarService.type$ | async as type">
    <ng-container *ngIf="snackbarService.message$ | async as message">
      <div
        class="snackbar"
        [ngClass]="{
          'snackbar--visible': isVisible,
          'snackbar--success': type === 'success',
          'snackbar--error': type === 'error',
          'snackbar--info': type === 'info',
          'snackbar--warning': type === 'warning',
        }"
      >
        <div class="snackbar__icon">
          <img *ngIf="type === 'success'" src="../../../../assets/icons/checkmark-outline.svg" alt="Success" />
          <img *ngIf="type === 'error'" src="../../../../assets/icons/error-outline.svg" alt="Error" />
        </div>

        <div class="snackbar__text">{{ message }}</div>
      </div>
    </ng-container>
  </ng-container>
</div>
